import "./bootstrap";
import { library, dom, config } from "@fortawesome/fontawesome-svg-core";

config.searchPseudoElements = true;
config.autoReplaceSvg = true;

import {
    faScrewdriverWrench,
    faUsers,
    faChartMixed,
    faFileUser,
    faUser,
    faUsersGear,
    faUserPlus,
    faArrowRightFromBracket,
    faPlus,
} from "@fortawesome/pro-thin-svg-icons";
import {
    faFilePlus,
    faSpinnerThird,
    faCircleNotch,
    faImages,
    faArrowRightToBracket,
    faArrowsRotate,
} from "@fortawesome/pro-regular-svg-icons";
import { faCircleUser } from "@fortawesome/pro-light-svg-icons";

library.add(
    faScrewdriverWrench,
    faUsers,
    faChartMixed,
    faFileUser,
    faFilePlus,
    faSpinnerThird,
    faCircleNotch,
    faImages,
    faUser,
    faUsersGear,
    faUserPlus,
    faCircleUser,
    faArrowRightFromBracket,
    faArrowRightToBracket,
    faArrowsRotate,
    faPlus
);
dom.i2svg();
dom.watch();

// vue init

import { createApp } from "vue";
import Leads from "./components/Leads.vue";
import InstallerLeads from "./components/InstallerLeads.vue";
import QuoteLeads from "./components/QuoteLeads.vue";
import AllOrders from "./components/AllOrders.vue";
import InstallerOrders from "./components/InstallerOrders.vue";

const app = createApp({});

app.component("leads", Leads);
app.component("installer-leads", InstallerLeads);
app.component("quote-leads", QuoteLeads);
app.component("all-orders", AllOrders);
app.component("installer-orders", InstallerOrders);

app.mount("#app");

// react init

import React from "react";
import { createRoot } from "react-dom/client";
import Configurator from "./pages/Configurator";
import { AppProvider } from "./context/AppContext";
import {faArrowLeft} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Navbar from "./components/Configurator/ui/Navbar";
import {Toaster} from "./components/Configurator/ui/Toaster";

const urlParams = new URLSearchParams(window.location.search);
const isTrade = urlParams.get('type') === 'trade';

if (document.getElementById("configurator")) {
    createRoot(document.getElementById("configurator")).render(
        <AppProvider>
            {!isTrade && <Navbar />}
            <Configurator/>
            <Toaster
                toastOptions={{
                    classNames: {
                        error: 'bg-red-100 text-red-700 border-red-200',
                        success: 'bg-green-100 text-green-700 border-green-200',
                        warning: 'text-yellow-400',
                        info: 'bg-blue-400',
                    },
                }}
            />
        </AppProvider>
    );
}
